import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'

const Home = lazy(() => import('./pages/Home'))
const Magazine = lazy(() => import('./pages/Magazine'))
const Issues = lazy(() => import('./pages/Issues'))
const Partners = lazy(() => import('./pages/Partners'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const Admin = lazy(() => import('./pages/Admin'))

function RouteFallback() {
  return <div className="min-h-screen bg-white" aria-label="Загрузка страницы" />
}

function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        {/* Журнал — отдельная страница (без Layout), удобно для новой вкладки */}
        <Route path="/magazine/:id" element={<Magazine />} />

        {/* Остальные страницы — внутри Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/issues" element={<Issues />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default App
